import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {
  public image:string='/assets/imgs/about.jpg';
  // public title:string='CentralCPD: passionate about veterinary learning';
  // public blurb:string='Jo Hillard BVM&S GPCert(SAM) MRCVS and The Central CPD Team.';
  public breadcrumbLinks=[];
  public thisPage:string='About';

  constructor() { }

  ngOnInit() {
  }

}

